module.exports = __webpack_public_path__ + "img/2.a9dc0812.jpg";